module.exports = __webpack_public_path__ + "img/qdl-logo.8cecf692.png";